import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import questionBankIcon from '../../../assets/img/question_bank/question_icon_blue.svg';
import GMATCalculator from '../../../common/Calculator/GMATCalculator';
import ComponentHeader from '../../../common/ComponentHeader';
import CustomButton from '../../../common/CustomButton';
import { renderHTMLContent } from '../../../common/function';
import { messages } from '../../../common/messages';
import FlashCard from '../../../components/FlashCard';
import ValidateSaveReportIcon from '../../../views/Common/ValidateSaveReportIcon';
import CustomCard from '../../QuestionBank/CustomCard';
import CustomCardBody from '../../QuestionBank/CustomCardBody';
import CustomCardHeader from '../../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../../QuestionBank/LoaderWrapper';
import ReportComponent from '../../ReportComponent';
import { CHOICE_KEYS, examNameAccordingToDB, QUESTION_TYPE } from '../../../common/constant';
import ViewQuestion from '../../QuestionBank/ViewQuestion';

export default class NormalQuestion extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      showCalculator: false,
      isError: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    await this.handleSetCurrentQuestion();
  }
  async componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
      this.handleSetCurrentQuestion();
    }
  }

  setDefaultChoice = (currentQuestionDetails, answerDetails) => {
    if (answerDetails.answer === 1) {
      return currentQuestionDetails.right_choice;
    }

    const selectedChoice = answerDetails.selected_choice;
    if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
      return selectedChoice;
    }

    const wrongChoices = CHOICE_KEYS.filter(
      (choice) => choice !== currentQuestionDetails.right_choice,
    );
    const chooseRandomChoice = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];

    return chooseRandomChoice;
  };

  setUserSelectedChoices = async () => {
    const { params, questionIds, questionTypes, apiServices, onHandleSetTimer } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];

    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.checkUserSelectedAnswer(payload);
    const { currentQuestion } = this.state;
    const received = response.question_recived || {};
    const selectedChoice = received.selected_choice || '';
    const { answer } = received;
    if (response.success) {
      this.setState({
        isUserSelectedChoice: parseInt(answer, 10) ? true : false,
        selectedChoice: this.setDefaultChoice(currentQuestion, received),
        isLoading: false,
        validated: !!response.question_recived,
      });
    } else {
      this.setState({
        isUserSelectedChoice: parseInt(answer, 10) ? true : false,
        selectedChoice,
        isLoading: false,
        validated: !!response.question_recived,
      });
    }
    onHandleSetTimer(!response.question_recived, !!response.question_recived);
  };

  handleSetCurrentQuestion = async () => {
    const { params, questionIds, questionTypes, apiServices } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];

    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.getQuestionById(payload);
    this.setState(
      {
        // isLoading: false,
        currentIndex: parseInt(offset, 10) || 0,
        currentQuestion: response.questionsbyid || {},
      },
      () => {
        this.getSavedQuestion(currentQuestionId);
        this.setUserSelectedChoices();
      },
    );
  };

  handleSaveQuestion = async () => {
    const { currentQuestion, reading, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id: currentQuestion.id,
      type,
      topic_name,
      reading_id,
    };

    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  resetStates = () => {
    this.setState({
      validated: false,
      isLoading: true,
      selectedAnswer1: '',
      selectedOptions: {},
      isError: false,
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  getPreviousQuestion = async () => {
    const { currentIndex } = this.state;
    const { handleChangeParams } = this.props;
    if (currentIndex > 0) {
      handleChangeParams(currentIndex - 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  getNextQuestion = async () => {
    const { currentIndex } = this.state;
    const { questionIds, handleChangeParams } = this.props;
    const nextIndex = currentIndex + 1;
    if (nextIndex < Object.keys(questionIds).length) {
      handleChangeParams(currentIndex + 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  setAnswer = (answer) => {
    this.setState({ selectedChoice: answer[0], isError: false });
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { selectedChoice, currentQuestion } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { quiz_id },
      onHandleSetTimer,
    } = this.props;
    if (!selectedChoice) {
      this.setState({
        isError: true,
      });
      return;
    }
    const isCorrect =
      selectedChoice.trim().toLowerCase() === currentQuestion.right_choice.trim().toLowerCase();

    onHandleSetTimer(false, true);

    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: Number(isCorrect),
      answer: Number(isCorrect),
      reading_id: currentQuestion['gmat_focus_reading.id'],
      quiz_id,
      selected_choice: selectedChoice,
      type: type === QUESTION_TYPE.CASE_QUESTION ? QUESTION_TYPE.QUESTION : type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      await apiServices.saveQuizAnswer(payload);
    }
  };

  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };

  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      showCalculator,
      selectedChoice,
      isError,
    } = this.state;
    const { apiServices, params, redirectToResults, questionType, questionIds, examName } =
      this.props;
    // Quiz routes like /begin-quiz/:quiz_id/:offset/:timer don't expose
    // question_id / readingid / reading in URL params (unlike non-quiz IR
    // routes). Pull the report fields from the loaded currentQuestion +
    // questionType prop so /reportQuestion gets real values instead of NULLs
    // — same pattern used for saveAttemptStats above.
    const { offset, quiz_id: quizId } = params;
    const question_id = currentQuestion && currentQuestion.id;
    const reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
    const topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
    const type = questionType;

    // Helper to render ValidateSaveReportIcon inside ViewQuestion
    const renderViewQuestion = () => (
      <ViewQuestion
        {...currentQuestion}
        {...this.props}
        setAnswer={this.setAnswer}
        showAnswer={validated}
        correctChoice={currentQuestion && currentQuestion.right_choice}
        selectedChoice={selectedChoice}
      >
        {isError && <div className='text-danger col-12'>{messages.NO_CHOICE_SELECTED}</div>}
        <div className='text-center mt-2 d-flex'>
          {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
          <ValidateSaveReportIcon
            isQue={true}
            showResult={validated}
            _getResult={this.handleValidate}
            _saveQuestion={this.handleSaveQuestion}
            _displayReportForm={this.reportCardToggle}
            all_questions={questionData}
            save_text={saveTooltipTitle}
            bookmarkCSS={bookmarkCSS}
            bookmarkColor={bookmarkColor}
          />
        </div>
      </ViewQuestion>
    );

    // Helper to render the answer feedback card
    const renderAnswerFeedback = () =>
      validated && (
        <Row>
          <Col>
            <CustomCard className='font-lusitana font-16px'>
              <CustomCardHeader
                headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
              />
              <CustomCardBody>{renderHTMLContent(currentQuestion.answer, 'span')}</CustomCardBody>
            </CustomCard>
          </Col>
        </Row>
      );

    // Helper to render the question content
    const renderQuestionContent = () => {
      if (!currentQuestion || !Object.keys(currentQuestion).length) {
        return <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>;
      }

      if (questionType === QUESTION_TYPE.CASE_QUESTION) {
        return (
          <CustomCard>
            <CustomCardHeader
              headingText={`(Q. ${parseInt(offset, 10) + 1})`}
              headerImage={questionBankIcon}
              arrayLength={Object.keys(questionIds).length}
              showPreviousButton
              showNextButton
              disabledPreviousButton={currentIndex < 1}
              disabledNextButton={currentIndex >= Object.keys(questionIds).length - 1}
              getPreviousQuestion={this.getPreviousQuestion}
              getNextQuestion={this.getNextQuestion}
            />
            <CustomCardBody>
              <Row>
                <Col
                  xs={5}
                  sm={12}
                  lg={5}
                  className='mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
                >
                  {renderHTMLContent(
                    examName === examNameAccordingToDB.EA
                      ? currentQuestion[`ea_case.passage`]
                      : currentQuestion[`gmat_case.passage`],
                    'div',
                    'text-left',
                  )}
                </Col>

                <Col
                  xs={5}
                  sm={12}
                  lg={5}
                  className='mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
                >
                  {renderViewQuestion()}
                </Col>
                <Col xs={2} sm={12} lg={2} className='text-center'>
                  {this.props.children}
                </Col>
              </Row>
            </CustomCardBody>
          </CustomCard>
        );
      }

      // Default (non-case) question
      return (
        <CustomCard>
          <CustomCardHeader
            headingText={`(Q. ${parseInt(offset, 10) + 1})`}
            headerImage={questionBankIcon}
            arrayLength={Object.keys(questionIds).length}
            showPreviousButton
            showNextButton
            disabledPreviousButton={currentIndex < 1}
            disabledNextButton={currentIndex >= Object.keys(questionIds).length - 1}
            getPreviousQuestion={this.getPreviousQuestion}
            getNextQuestion={this.getNextQuestion}
          />
          <CustomCardBody>
            <Row>
              <Col xs={10} sm={12} lg={10} className='mb-0 mb-sm-1 question-view'>
                {renderViewQuestion()}
              </Col>
              <Col xs={2} sm={12} lg={2} className='text-center'>
                {this.props.children}
              </Col>
            </Row>
          </CustomCardBody>
        </CustomCard>
      );
    };

    return (
      <div>
        <ComponentHeader title={`${messages.QUIZ_ID}: ${quizId}`}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() => this.setState({ showCalculator: true })}
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectToResults()}>
              {messages.BACK_TO_SUMMARY}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>{renderQuestionContent()}</LoaderWrapper>

        {renderAnswerFeedback()}

        <FlashCard
          item={{ id: currentQuestion && currentQuestion.id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        {/* //TODO: Remove the ! from the common component */}
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/Quiz/NormalQuestion.jsx